// The same arithmetic as FoodTable::Calculator on the server, so a weight corrected while reviewing a meal updates
// its numbers at once (the server works them out again when the meal is saved). An item from the food table keeps
// a copy of the table's values per 100 g (`per100`, with the cooked factor); one the AI estimated keeps the AI's
// numbers for its grams (`ai`).
const MACROS = ['protein_g', 'carbs_g', 'fat_g', 'fiber_g'];
const round1 = (n) => Math.round(n * 10) / 10;

export const SOURCE_CREDIT = 'Nguồn: Viện Dinh dưỡng – Bảng thành phần thực phẩm Việt Nam (2007)';

// Meals analysed with the food table have a source on their items; older ones don't.
export const hasSources = (items) => Array.isArray(items) && items.some((i) => i.source);

// Some of these numbers were looked up in the tables (Viện Dinh dưỡng or USDA), not only guessed by the AI: the
// source line shows. Each item keeps which table (`origin`: vn | usda, or ai for an AI estimate an admin kept as a
// food: not from a table, so it doesn't count).
export const usesTables = (items) => Array.isArray(items) && items.some((i) => i.source === 'table' && i.origin !== 'ai');

export function recompute(item, grams) {
  const g = Math.min(2000, Math.max(1, Number(grams) || 0));
  if (item.source === 'ai') {
    const ratio = item.ai?.grams > 0 ? g / item.ai.grams : 0;
    return { ...item, grams: g, calories: Math.round((item.ai?.calories || 0) * ratio),
      ...Object.fromEntries(MACROS.map((k) => [k, round1((item.ai?.[k] || 0) * ratio)])) };
  }
  const factor = item.state === 'cooked' && item.per100?.factor > 0 ? item.per100.factor : 1;
  const raw = g / factor;
  return { ...item, grams: g, calories: Math.round(((item.per100?.kcal || 0) * raw) / 100),
    ...Object.fromEntries(MACROS.map((k) => [k, round1(((item.per100?.[k] || 0) * raw) / 100)])) };
}

export function totals(items) {
  const sum = (k) => items.reduce((s, i) => s + (Number(i[k]) || 0), 0);
  return { calories: Math.round(sum('calories')), ...Object.fromEntries(MACROS.map((k) => [k, round1(sum(k))])) };
}
